import { createAsyncThunk } from "@reduxjs/toolkit";

import { getDeploymentSettingsRequest } from "Api/organizations/projects/getDeploymentSetting.request";
import logger from "Libs/logger";
import { isJson } from "Libs/utils";

import type { DeploymentSettings } from "../types";
import type { AsyncThunkOptionType } from "Reducers/types";

export const loadDeploymentSettings = createAsyncThunk<
  DeploymentSettings,
  { projectId: string; environmentId: string; organizationId: string },
  AsyncThunkOptionType
>(
  "app/environmentDeploymentSettings/load",
  async ({ projectId, environmentId }, { rejectWithValue }) => {
    try {
      const deploymentSettings = await getDeploymentSettingsRequest({
        projectId,
        environmentId
      });

      return deploymentSettings;
    } catch (error) {
      const errorMessage = isJson(error)
        ? error
        : "An error occurred while attempting to load deployment settings.";
      logger(errorMessage, {
        action: "load_deployment_settings"
      });

      return rejectWithValue(error as { code: number; message: string });
    }
  }
);
